<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('document_type')">
                    <div class="label-as-input">{{ isNotNullValue(form.document_type_name) || isNotNullValue(form.document_type) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('date_of_document')">
                    <div class="label-as-input">{{ isNotNullValue(form.date_of_document) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('index_by_bau')">
                    <div class="label-as-input">{{ isNotNullValue(form.index_by_bau) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group :label="$t('index_of_document')">
                    <div class="label-as-input">{{ isNotNullValue(form.index_of_document) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6" v-if="['outgoing_document'].includes(form.document_type)">
                <b-form-group :label="$t('name_of_sender')">
                    <div class="label-as-input">{{ isNotNullValue(form.name_of_sender) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                <b-form-group :label="$t('name_of_recipient')">
                    <div class="label-as-input">{{ isNotNullValue(form.name_of_recipient) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                <b-form-group :label="$t('executor')">
                    <div class="label-as-input">{{ isNotNullValue(form.executor) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                <b-form-group :label="$t('delivery_type')">
                    <div class="label-as-input">{{ isNotNullValue(form.delivery_type_name) || isNotNullValue(form.delivery_type) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
                <b-form-group :label="$t('number_of_pages')">
                    <div class="label-as-input">{{ isNotNullValue(form.number_of_pages) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6" v-if="['rectors_order', 'business_partner_meeting', 'academic_council_order', 'faculty_council_order', 'minutes', 'agreements'].includes(form.document_type)">
                <b-form-group :label="$t('grade')">
                    <div class="label-as-input">{{ isNotNullValue(form.grade) }}</div>
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group :label="$t('explanation')">
                    <div class="label-as-input text-break" style="min-height: 80px;">{{ isNotNullValue(form.explanation) }}</div>
                </b-form-group>
            </b-col>

            <template v-if="['agreements'].includes(form.document_type)">
                <b-col cols="6" md="6">
                    <b-form-group :label="$t('start_date')">
                        <div class="label-as-input">{{ isNotNullValue(form.start_date) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="6" md="6">
                    <b-form-group :label="$t('end_date')">
                        <div class="label-as-input">{{ isNotNullValue(form.end_date) }}</div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('type_of_agreement')">
                        <div class="label-as-input">{{ isNotNullValue(form.type_of_agreement_name) || isNotNullValue(form.type_of_agreement) }}</div>
                    </b-form-group>
                </b-col>
            </template>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('document_file')">
                    <div class="label-as-input">
                        <span v-if="form.file && form.file.file_name">{{ form.file.file_name }}</span>
                        <span v-else>-</span>
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('annex')">
                    <div class="label-as-input">
                        <span v-if="form.annex && form.annex.file_name">{{ form.annex.file_name }}</span>
                        <span v-else>-</span>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import AdministrativeDocumentManagementService from '@/services/AdministrativeDocumentManagementService';

export default {
    props: {
        formId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            formLoading: false,
            form: {
                document_type: null,
            }
        }
    },
    async created() {
        if (this.formId) {
            await this.get(this.formId)
        }
    },
    methods: {
        get(id) {
            this.formLoading = true;
            AdministrativeDocumentManagementService.get(id)
                .then((response) => {
                    this.form = response.data.data;
                })
                .catch((error) => {
                    this.showErrors(error);
                })
                .finally(() => {
                    this.formLoading = false;
                });
        },
    }
}
</script>
